import React from 'react'

import { Col, Grid } from '../structure/Grid'
import { useCalendar } from './CalendarHandler'
import Icon from '../shapes/Icon'
import Text from '../presentation/Text'

const useTitle = () => {
  const { perspective, date, startAt, endAt } = useCalendar()
  switch (perspective) {
    case 'month':
      return date.format('MMMM')
    case 'week':
      return startAt.format('DD/MMM') + ' - ' + endAt.format('DD/MMM')
    default:
      return date.format('DD - MMMM')
  }
}

const CalendarDateNavigation = () => {
  const { date, onAdd } = useCalendar()
  const title = useTitle()

  return (
    <Grid gap={0.4} align="center">
      <Icon color="dark3" name="RiArrowLeftSFill" onClick={() => onAdd(-1)} size={1.2} />
      <Col align="center">
        <Text bold size="xxsmall" marginTop={-0.9} marginBottom={-0.25}>
          {date.format('YYYY')}
        </Text>
        <Text bold size="h4">
          {title}
        </Text>
      </Col>
      <Icon color="dark3" name="RiArrowRightSFill" onClick={() => onAdd(+1)} size={1.2} />
    </Grid>
  )
}

export default CalendarDateNavigation
